/**
 * ApTemplateType
 *
 * @hidden
 * Should match server enum found at EE.Api/Entities/ApTemplateType.cs
 */
export enum ApTemplateType {
    instance = 'Instance',
    global = 'Global',
    client = 'Client',
}
